// Global actions
export const GLOBAL_LANGUAGE_SET = 'global_language_set'
export const GLOBAL_CHOICE_SET = 'global_choice_set'
export const GLOBAL_COORDS_SET = 'global_coords_set'

// Things Actions
export const THING_ERROR = 'thing_error'
export const THING_RESET = 'thing_reset'
export const THING_ALL = 'thing_all'
export const THING_ALL_PENDING = 'thing_all_pending'